import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ModalDismissReasons, NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ClipboardService } from 'ngx-clipboard';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { AppointmentGenericTabs, Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { ApointmentModuleNames, AppointmentStatus, AppointmentType, FeatureCode, TemplateScope, WorkOrderStatus, WOStatus } from 'projects/Autofacets-Core/src/app/utils/enums';
import * as Enums from 'projects/Autofacets-Core/src/app/utils/enums';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { AppointmentList } from '../../../business-entities/appointmentList-model';
import { SSMRequestModel } from '../../../business-entities/SSMRequest-model';
import { Features } from '../../../business-entities/user-role-view-model';
import { AppointmentWorkOrderService } from '../../../business-services/appointment-work-order.service';
import { AppointmentService } from '../../../business-services/appointment.service';
import { EditAppointmentService } from '../../../business-services/edit-appointment.service';
import { RolesRightsService } from '../../../business-services/roles-rights.service';
import { SSMBusinessService } from '../../../business-services/SSM.service';
import { RomnasService } from '../../../business-services/romnas.service';
import { AppointmentAdditionalWorkComponent } from './appointment-additional-work/appointment-additional-work.component';
import { AppointmentCommunicationComponent } from './appointment-communication/appointment-communication.component';
import { AppointmentDocumentComponent } from './appointment-document/appointment-document.component';
import { AppointmentDWOComponent } from './appointment-DWO/appointment-dwo/appointment-dwo.component';
import { DwoChecklistComponent } from './appointment-DWO/appointment-dwo/dwo-checklist/dwo-checklist/dwo-checklist.component';
import { AppointmentParkingComponent } from './appointment-parking/appointment-parking/appointment-parking.component';
import { AppointmentPlanningComponent } from './appointment-planning/appointment-planning.component';
import { AppointmentUpdateComponent } from './appointment-update/appointment-update.component';
import { AppointmentWorkOrderHistoryComponent } from './appointment-work-order-history/appointment-work-order-history.component';
import { AppointmentWorkOrderComponent } from './appointment-work-order/appointment-work-order.component';
import { PDFAppointmentOrderComponent } from './pdf-appointment-order/pdf-appointment-order.component';
import { SendNotificationComponent } from './send-notification/send-notification.component';
import { TecRmiLabourPopupComponent } from './tec-rmi-labour-popup/tec-rmi-labour-popup.component';
import { TecRmiPopupComponent } from './tec-rmi-popup/tec-rmi-popup.component';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { UserRoleMenu } from '../../../business-entities/user-role-menu.model';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { NgInfoModalContent } from 'projects/Autofacets-Core/src/app/shared/info-modal.component';
import { DeleteWorkorderComponent } from '../../../components/delete-workorder/delete-workorder.component';
import { InvoiceWarningPopupComponent } from './invoice-warning-popup/invoice-warning-popup.component';
import { AppointmentInvoiceComponent } from './appointment-invoice/appointment-invoice.component';
import { AppointmentCommonService } from '../../../business-services/appointment-common.service';
import { WhatsAppMessagesComponent } from '../whatsapp-messages/whatsapp-messages.component';
import { ManualNotificationRecipientList, ManualNotificationRequestModel, TemplateLegendResponseModel } from '../../../business-entities/manual-notification-model';
import { DealerDataService } from '../../../data-services/dealer-data.service';
import {NotificationLogService } from '../../../business-services/notification-log.service';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { Comments } from 'projects/Administration/src/app/business-entities/dwo-comments.model';
import { DwoDocumentsBusinessService } from '../../../business-services/dwo-documents.service';
import { MpoBussinessService } from '../../../business-services/mpo.service';
import { AppLinkService } from '../../../business-services/app-link.service';

import Quill from 'quill';
import { ShareboxLogComponent } from './sharebox-log/sharebox-log.component';
import { DecimalPipe } from '@angular/common';
@Component({
  selector: 'app-edit-appointment',
  templateUrl: 'edit-appointment.component.html',
  styleUrls: ['./edit-appointment.component.css']
})

export class EditAppointmentComponent implements OnInit, OnDestroy {
  @ViewChild(AppointmentWorkOrderComponent) child: AppointmentWorkOrderComponent;
  @ViewChild(AppointmentAdditionalWorkComponent) childAppointmentAdditionalWorkComponent: AppointmentAdditionalWorkComponent;
  @ViewChild(AppointmentPlanningComponent) childAppointmentPlanningComponent: AppointmentPlanningComponent;
  @ViewChild(AppointmentDWOComponent) childAppointmentDWOComponent: AppointmentDWOComponent;
  @ViewChild(AppointmentCommunicationComponent) childAppointmentCommunicationComponent: AppointmentCommunicationComponent;
  @ViewChild(AppointmentParkingComponent) childAppointmentParkingComponent: AppointmentParkingComponent;
  @ViewChild(AppointmentWorkOrderHistoryComponent) childAppointmentWorkOrderHistoryComponent: AppointmentWorkOrderHistoryComponent;
  @ViewChild(AppointmentDocumentComponent) childAppointmentDocumentComponent: AppointmentDocumentComponent;
  @ViewChild(AppointmentUpdateComponent) childAppointmentHistoryComponent: AppointmentUpdateComponent;
  @ViewChild(DwoChecklistComponent) childDwoChecklistComponent: DwoChecklistComponent;
  @ViewChild(AppointmentInvoiceComponent) chileAppointmentInvoiceComponent: AppointmentInvoiceComponent;
  @ViewChild(WhatsAppMessagesComponent) chileWhatsAppMessagesComponent: WhatsAppMessagesComponent;
  @ViewChild(ShareboxLogComponent) childShareboxLogComponent: ShareboxLogComponent;
  @ViewChild('emailQuillEditor') emailQuillEditor: any;
  isViewAppointmentFromWAR:boolean = false;  
  appointmentDetails: AppointmentList;
  features: Features[] = [];
  condition: boolean = false;
  licensePlateClass: string;
  pdfToolTip: string;
  contactDetails: any;
  isDisplyDownloadOrderButton: boolean = false;
  isOpenByOtherUserMsg: string = '';
  isDisplyInvoice: boolean = false;
  shareBox: boolean = false;
  message: any;
  isShareboxReminderNeeded:boolean = false;
  featureList: Features[] = [];
  isDMSEnable: boolean = false;
  isDmsPackageSync: boolean = false;
  userRoleRightsDetails: UserRoleMenu;
  isGenerateInvocie: boolean = false;
  @Input() isOpenWhatsAppTab:boolean = false;
  appointmentId:number;
  customerName:string;
  customerContactNo:string;
  @Input() isOpenFromPlanning: boolean = false;
  selectedLanguage: string;
  comments: Comments[];
  customerComments: Comments[] = [];
  closeResult: string;
  confirmAppointmentEmail: string;
  isMg = false;
  quill: Quill;
  quillInstance: any;
  options = {
    toolbar: {
      container: [
        [{'undo':'Undo'}, {'redo': 'Redo'}],
        [{'direction': 'rtl'}, 'blockquote'],
        [{ 'header': 1 }, { 'header': 2 }, { 'header': 3 }, { 'header': 4 }],
        ['bold', 'italic', 'strike'],
        [{'script': 'super'}, {'script': 'sub'}],
        ['link'],
        [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
        [{'list': 'ordered'}, {'list': 'bullet'}],
        ['clean']
      ],
      handlers: {
        redo() {
          this.quill.history.redo();
        },
        undo() {
          this.quill.history.undo();
        }
      }
    },
    history: {delay: 500, maxStack: 500, userOnly: true}
  };

  constructor(private readonly modalService: NgbModal,
    private readonly activeModal: NgbActiveModal,
    private readonly appointmentService: AppointmentService,
    private readonly cookieservice: CookieService,
    private readonly secureStorage: SecureStorage,
    public editAppointmentService: EditAppointmentService,
    public workorderService: AppointmentWorkOrderService,
    private readonly globalSetting: GlobalSetting,
    private readonly translate: TranslateService,
    private readonly clipboardApi: ClipboardService,
    private readonly SSMservice: SSMBusinessService,
    private readonly toastr: ToastrService,
    private readonly spinner: NgxSpinnerService,
    private readonly roleRightsService: RolesRightsService,
    private readonly userService: UserDataService,
    private readonly commonService: AppointmentCommonService,
    private readonly romnasService: RomnasService,
    private readonly notificationService: NotificationLogService,
    private readonly currentLanguageService: CurrentLanguage,
    private readonly dwoDocumentsBusinessService: DwoDocumentsBusinessService,
    private readonly appLinkService: AppLinkService,
    private readonly dealerDataService: DealerDataService,
    private readonly mpoService: MpoBussinessService,
    private readonly cdr: ChangeDetectorRef,
    private readonly decimalPipe: DecimalPipe
  ) {
      if (this.editAppointmentService.appointmentDetails.appointmentType === AppointmentType.OFFER) {
        this.editAppointmentService.AppointmentGenericTabs = AppointmentGenericTabs.filter(
          x=> x.id == ApointmentModuleNames.WorkOrder
          || x.id == ApointmentModuleNames.WorkOrderHistory
          || x.id == ApointmentModuleNames.Updates);
      }
      else{
        this.editAppointmentService.AppointmentGenericTabs = AppointmentGenericTabs.filter(
          x => x.id !== ApointmentModuleNames.DWO
          && x.id !== ApointmentModuleNames.Parking
          && x.id !== ApointmentModuleNames.Documents
          && x.id !== ApointmentModuleNames.Invoie
          //&& x.id !== ApointmentModuleNames.WhatsApp
          );
      }
  }
  selectedtab: number = 1;
  updatedModalRef: NgbModalRef = null;
  isRefreshTab: boolean = false;
  isDisplayCheckInTrackerUrl: boolean = true;
  integrationWithDMS: boolean = false;
  isDsoActive: boolean = false;
  isScriveActive: boolean = false;
  isWhatsappActive: boolean = false;
  isSSTActive: boolean = false;
  tecRmiLoginUrl: any;
  closeFromAppiontmentWO: boolean = false;
  ngOnInit(): void {
    this.commonService.SelectedStatus = null;
    this.isMg = localStorage.getItem('Theme') === 'mg';
    this.features = this.secureStorage.getKeyData('feature');
    if (this.features == null || this.features == undefined) {
      this.currentLanguageService.featureList.subscribe((res) => {
        this.features = res;
        this.shareBox = this.features.find(x => x.featureCode === Enums.FeatureCode.ShareBox)?.isActive;
      })
    }
    this.isSSTActive = this.features.find(x => x.featureCode === Enums.FeatureCode.SST)?.isActive;
    this.shareBox = this.features.find(x => x.featureCode === Enums.FeatureCode.ShareBox)?.isActive;
    this.currentLanguageService.currentLanguage.subscribe((res) => {
      this.selectedLanguage = res;
    })
    this.selectedtab = this.isOpenWhatsAppTab ? 11 : 1;
    this.appointmentId = this.editAppointmentService.appointmentDetails.id;
    this.customerName = this.editAppointmentService.appointmentDetails.customerName;
     this.customerContactNo = "+" + this.editAppointmentService.appointmentDetails.customerMobileCode
       + this.editAppointmentService.appointmentDetails.mobileNo
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === Enums.ModuleNames.Appointment);
    this.IsLockedByOtherUser();
    this.GetServiceDetail();
    this.editAppointmentService.exportedJson = "";
    this.editAppointmentService.isExported = false;
    this.editAppointmentService.isSSMEnabled = false;
    this.editAppointmentService.isRomnasEnabled = false;
    this.editAppointmentService.isTecRMIEnabled = false;
    this.editAppointmentService.isFromMpo = false;
    this.editAppointmentService.exportedMpoData = null;
    this.appointmentDetails = this.editAppointmentService.appointmentDetails;
    if (this.appointmentDetails.appointmentStatusId === AppointmentStatus.InvoiceReady || this.appointmentDetails.appointmentStatusId === AppointmentStatus.Closed) {
      this.condition = true;
    }
    else {
      // Removed to stop rendering of Whatsapp integration
      //let feature = FeatureCode.DWO + "," + FeatureCode.SSM + "," + FeatureCode.TecRMI + "," + FeatureCode.Romnas + "," + FeatureCode.Scrive + "," + FeatureCode.INVGN+ "," + FeatureCode.WhatsApp;
      let feature = FeatureCode.DWO + "," + FeatureCode.SSM + "," + FeatureCode.TecRMI + "," + FeatureCode.Romnas + "," + FeatureCode.Scrive + "," + FeatureCode.INVGN+ ","  + FeatureCode.DMS + "," + FeatureCode.MPO + "," + FeatureCode.SST
      this.roleRightsService.getFeatureByDealerId(feature, this.appointmentDetails.dealerId, this.appointmentDetails.brandCode).then((res) => {
        if (res.responseObject?.result) {
          this.features = res.responseObject?.result;
          if (this.features && this.features.length > 0) {
            //theme condition added by dharmendra tempororly until, DMS integration not completed with MG
            this.integrationWithDMS = localStorage.getItem("Theme") == 'mg'? false :  this.features.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive;
            this.isDsoActive = this.features.find(x => x.featureCode === FeatureCode.DWO)?.isActive;
            this.isScriveActive = this.features.find(x => x.featureCode === FeatureCode.Scrive)?.isActive;
            let isInvoice = this.features.find(x => x.featureCode === FeatureCode.INVGN)?.isActive;
            this.isWhatsappActive = this.features.find(x => x.featureCode === FeatureCode.WhatsApp)?.isActive;
            this.isSSTActive = this.features.find(x => x.featureCode === FeatureCode.SST)?.isActive;
            if (this.isDsoActive && this.appointmentDetails.appointmentType !== AppointmentType.OFFER) {
              this.addAppointmentTab(ApointmentModuleNames.DWO);
              this.addAppointmentTab(ApointmentModuleNames.Parking);
            }
            // Removed to stop rendering of Whatsapp integration
            // if (this.isWhatsappActive) {
            //   this.addAppointmentTab(ApointmentModuleNames.WhatsApp);
            // }
            if (this.isScriveActive && this.appointmentDetails.appointmentType !== AppointmentType.OFFER) {
              this.addAppointmentTab(ApointmentModuleNames.Documents);
            }
            if ((isInvoice && this.userService?.currentUserValue?.userRoleMenuDetails?.find(x=>x.moduleId === Enums.ModuleNames.AllowInvoiceFeature)?.canView) && this.appointmentDetails.appointmentType !== AppointmentType.OFFER) {
              this.addAppointmentTab(ApointmentModuleNames.Invoie);
            }
            let SSMFeature = this.features.find(x => x.featureCode === FeatureCode.SSM) && !this.editAppointmentService.appointmentDetails.isFromArchive;
            this.editAppointmentService.isSSMEnabled = (SSMFeature != null || SSMFeature != undefined) ? true : false;
            let tecRMIFeature = this.features.find(x => x.featureCode === FeatureCode.TecRMI) && !this.editAppointmentService.appointmentDetails.isFromArchive
            this.editAppointmentService.isTecRMIEnabled = (tecRMIFeature != null || tecRMIFeature != undefined) ? true : false;
            if (this.editAppointmentService.isTecRMIEnabled) {
              this.tecRmiLoginUrl = this.features.find(x => x.featureCode === FeatureCode.TecRMI)?.serviceUrl2;
            }
            let MPOFeature = this.features.find(x => x.featureCode === FeatureCode.MPO) && !this.editAppointmentService.appointmentDetails.isFromArchive;
            this.editAppointmentService.isMPOEnabled = (MPOFeature != null || MPOFeature != undefined) ? true : false;
            let romnasFeature = this.features.find(x => x.featureCode === FeatureCode.Romnas) && !this.editAppointmentService.appointmentDetails.isFromArchive
            this.editAppointmentService.isRomnasEnabled = (romnasFeature != null || romnasFeature != undefined) ? true : false;
            this.loadErrorMessage();
          }
        }
        //Removed due to #4656 and #4793
        //if(this.appointmentDetails.workOrderStatusId === WOStatus.Workdone || this.appointmentDetails.workOrderStatusId === WOStatus.Invoiceready || this.appointmentDetails.workOrderStatusId === WOStatus.InvoicePaid || this.appointmentDetails.workOrderStatusId === WOStatus.Closed || this.appointmentDetails.appointmentType === AppointmentType.OFFER){
        if (this.appointmentDetails.workOrderStatusId === WOStatus.Workdone || this.appointmentDetails.appointmentType === AppointmentType.OFFER) {
          this.editAppointmentService.isDownloadOffer = true;
        }
        else{
          this.editAppointmentService.isDownloadOffer = false;
        }
        if (this.appointmentDetails.workOrderStatusId === WOStatus.Workdone || this.appointmentDetails.workOrderStatusId === WOStatus.Mechanicdone || this.appointmentDetails.workOrderStatusId === WOStatus.Invoiceready) {
          //this.isGenerateInvocie = true;
          if (!this.appointmentDetails.isInvoiceCompleted) {
            this.featureList = this.secureStorage.getKeyData('feature');
            if (this.featureList && this.featureList.length > 0) {
              if(this.featureList.find(x => x.featureCode === Enums.FeatureCode.INVGN)?.isActive 
                 && this.userService?.currentUserValue?.userRoleMenuDetails?.find(x=>x.moduleId === Enums.ModuleNames.AllowInvoiceFeature)?.canView){
                  this.isGenerateInvocie = true;
                 }
            }
          }
        }
        if (this.appointmentDetails.appointmentType === AppointmentType.ORDER || AppointmentType.OFFER) {
          this.isDisplyDownloadOrderButton = true;
        }
      })
    }

    this.licensePlateClass = this.globalSetting.getGlobalLicencePlate();
    this.setPdfToolTipBasedOnWorkOrderStatus();
    if (this.editAppointmentService.appointmentDetails.workOrderStatusId !== Enums.WOStatus.WorkRequest &&
      this.editAppointmentService.appointmentDetails.workOrderStatusId !== Enums.WOStatus.Cancelled &&
      !this.editAppointmentService.appointmentDetails.isFromArchive &&
      this.editAppointmentService.appointmentDetails.licensePlate
    ) {
      this.appLinkService.GetCheckInUrl(this.appointmentDetails.appointmentGuid).then(x => {
        this.editAppointmentService.checkInURL = x?.checkInTinyUrl;
      }).finally(() => { this.spinner.hide(); });
    }

    if ((this.editAppointmentService.appointmentDetails.workOrderStatusId !== Enums.WOStatus.WorkRequest) &&
      (this.editAppointmentService.appointmentDetails.workOrderStatusId !== Enums.WOStatus.Prepared) &&
      (this.editAppointmentService.appointmentDetails.workOrderStatusId !== Enums.WOStatus.Cancelled &&
        !this.editAppointmentService.appointmentDetails.isFromArchive &&
        this.editAppointmentService.appointmentDetails.licensePlate) &&
        this.editAppointmentService.appointmentDetails.bookedDate != null && this.editAppointmentService.appointmentDetails.bookedDateTime
      ) {
      this.appLinkService.GetTrackerLink(this.appointmentDetails.appointmentGuid).then(x => {
        this.editAppointmentService.trackerURL = x;
      }).finally(() => { this.spinner.hide(); });
    }

    if (this.editAppointmentService.appointmentDetails) {
      this.getComments(this.editAppointmentService.appointmentDetails.id);
    }

    this.editAppointmentService.isRefreshFromCreateQuote.subscribe((res) => {
      if (res) {
        this.refreshFromQuote();
        this.editAppointmentService.isRefreshFromCreateQuote.next(false);
      }
    });
  }

  getComments(id) {
    this.spinner.show()
    this.comments = [];
    this.dwoDocumentsBusinessService.getDwoComments(id).then((res) => {
      if (res.responseObject) {
        this.comments = res.responseObject
        if (this.comments?.length !== undefined) {
          this.comments.forEach(x => { if (x.updatedDate !== null) x.updatedDate = Utility.ConvertUTCDateToLocalDate(x.updatedDate) });
          this.customerComments = this.comments.filter(x => x.isCustomerComment && x.isInternalComments == 0 && x.comment);
        }
      }
    }).finally(() => {
      this.spinner.hide();
    });
  }

  ViewComment(viewContent) {
    this.modalService.open(viewContent, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.commonService.getDismissReason(reason)}`;
    });
  }

 
  

  loadErrorMessage(newPlanningStartDate?: any) {
    this.message = '';
    let isShowDMSMessage = localStorage.getItem("Theme") === 'mg'? false : true;
    let isBNH = localStorage.getItem("Theme") === 'bnh'? true : false;
    if (!isBNH) {
      if (this.shareBox) {
        if (newPlanningStartDate != null) {
          const currentDateTime = new Date();
          const bookedDateTime = new Date(newPlanningStartDate);
          const timeDifferenceInHours = (bookedDateTime.getTime() - currentDateTime.getTime()) / (1000 * 60 * 60);
          this.isShareboxReminderNeeded = timeDifferenceInHours <= 24 && timeDifferenceInHours > 0;
          if (this.isShareboxReminderNeeded && this.editAppointmentService.appointmentDetails.bookedDateTime != null && !this.editAppointmentService.appointmentDetails.sentShareboxInfo) {
            let shareboxMessage = this.translate.instant("lblShareboxReminderMessage")
            this.message += this.message == '' ? shareboxMessage : ', ' + shareboxMessage;
          }
        } else {
          const currentDateTime = new Date();
          const bookedDateTime = new Date(Utility.ConvertUTCDateToLocalDate(this.editAppointmentService.appointmentDetails.bookedDateTime));
          const timeDifferenceInHours = (bookedDateTime.getTime() - currentDateTime.getTime()) / (1000 * 60 * 60);
          this.isShareboxReminderNeeded = timeDifferenceInHours <= 24 && timeDifferenceInHours > 0;
          if (this.isShareboxReminderNeeded && this.editAppointmentService.appointmentDetails.bookedDateTime != null && !this.editAppointmentService.appointmentDetails.sentShareboxInfo) {
            let shareboxMessage = this.translate.instant("lblShareboxReminderMessage")
            this.message += this.message == '' ? shareboxMessage : ', ' + shareboxMessage;
          }
        }
      }
    }
    if (this.integrationWithDMS && !this.editAppointmentService.appointmentDetails.isFromArchive && this.editAppointmentService.appointmentDetails.dmsSyncStatus == 0 && this.editAppointmentService.appointmentDetails.appointmentType !== 'Quote' && isShowDMSMessage) {
      this.message += this.translate.instant("lblDMSSyncFail");
    }
    if (this.editAppointmentService.appointmentDetails.reasonForCancellation) {
      let appointmentCancelReason = this.translate.instant("lblReasonForCancellation") + ': ' + this.editAppointmentService.appointmentDetails.reasonForCancellation;
      this.message += this.message == '' ? appointmentCancelReason : ', ' + appointmentCancelReason
    }
    if (this.editAppointmentService.appointmentDetails.reasonForDeletion) {
      let appointmentDeleteReason = this.translate.instant("lblReasonForArchive") + ': ' + this.editAppointmentService.appointmentDetails.reasonForDeletion;
      this.message += this.message == '' ? appointmentDeleteReason : ', ' + appointmentDeleteReason
    }
    if (this.editAppointmentService.appointmentDetails.appointmentType == 'Quote' && this.editAppointmentService.appointmentDetails.isQuoteExipred) {
      let appointmentExpired = this.translate.instant("lblQuoteExpired");
      this.message += this.message == '' ? appointmentExpired : ', ' + appointmentExpired;
    } 
  }

  setPdfToolTipBasedOnWorkOrderStatus() {
    const statusId = this.appointmentDetails?.workOrderStatusId?.toString();

    if (statusId === WorkOrderStatus.InvoiceReady || statusId === WorkOrderStatus.InvoicePaid ||
      statusId === WorkOrderStatus.Closed) {
      this.pdfToolTip = this.translate.instant("lblDownloadInvoice");
    }
    else if (statusId === WorkOrderStatus.WorkRequest) {
      this.pdfToolTip = this.translate.instant("lblDownloadOffer");
    }
    else if (statusId === WorkOrderStatus.WorkDone) {
      this.pdfToolTip = this.translate.instant("lblDownloadOrderConfirmation");
    }
  }

  onGetContactDetail(contactDetails: any) {
    this.contactDetails = contactDetails;
  }

  refreshTab(event: any) {
    if (event) {
      this.onRefresh();
    }
  }
  addAppointmentTab(tabId: number) {
    let tab = AppointmentGenericTabs.find(x => x.id == tabId);
    if (!this.editAppointmentService.AppointmentGenericTabs.includes(tab)) {
      this.editAppointmentService.AppointmentGenericTabs.push(tab);
    }
    this.editAppointmentService.AppointmentGenericTabs = this.editAppointmentService.AppointmentGenericTabs.sort((x, y) => x.id - y.id);
  }
  copyLicencePlateNo() {
    this.clipboardApi.copyFromContent(this.appointmentDetails.licensePlate)
  }
  copyTextWoNumber() {
    this.clipboardApi.copyFromContent(this.appointmentDetails.workOrderNo)
  }
  isCheckin() {
    if (this.editAppointmentService.appointmentDetails.appointmentType === 'Quote' && this.editAppointmentService.trackerURL == null && this.editAppointmentService.checkInURL == null) {
      let checkInMessageWarning = this.translate.instant("lblcheckInMessageWarning");
      this.toastr.warning(checkInMessageWarning);
    }
    else if (this.editAppointmentService.trackerURL == null && this.editAppointmentService.checkInURL == null) {
      let checkInMessageWarning = this.translate.instant("lblCheckInLinkGenerationIsInProgress");
      this.toastr.warning(checkInMessageWarning);
    }
    else if (this.editAppointmentService.appointmentDetails.dmsSyncStatus === 0) {
      this.isDisplayCheckInTrackerUrl = false;
      let checkInMessageWarning = this.translate.instant("lblSyncAppointmentToViewCheckinLink");
      this.toastr.warning(checkInMessageWarning);
    }
  }

  openCheckIn(){
    if(this.editAppointmentService.appointmentDetails.bookedDate == null && this.editAppointmentService.appointmentDetails.bookedDateTime == null){
      let failedMessage = this.translate.instant("lblPleaseAddAppointmentPlanning");
      this.toastr.error(failedMessage);
    }
    else{
      window.open(this.editAppointmentService.checkInURL, '_blank');
    }
  }

  async GetServiceDetail() {
    const languageCode = this.cookieservice.get('userSelectedLanguage');
    await this.appointmentService.GetServiceDetail(this.editAppointmentService.appointmentDetails.id, '', languageCode).then(data => {
     this.editAppointmentService.appointmentDemandList = data.responseObject.appointmentDemandList;
     this.workorderService.isAnyWarrantyDemandExists = this.editAppointmentService.appointmentDemandList?.find(x => x.isInWarranty)?.isInWarranty ?? false;
     this.editAppointmentService.appointmentJobDetailsList = data.responseObject.appointmentJobDetailList;
    })
  }

  openParking() {
    this.selectedtab = 6;
  }
  async showPdfIcon(value: number): Promise<void> {
    this.editAppointmentService.isDownloadOffer = false;
    this.isGenerateInvocie = false;
    if (value == 1) {
      this.editAppointmentService.isDownloadOffer = true;
    } else if (value == 2) {
      //this.isGenerateInvocie = true;
      if (!this.editAppointmentService.appointmentDetails.isInvoiceCompleted) {
        this.featureList = this.secureStorage.getKeyData('feature');
        if (this.featureList && this.featureList.length > 0) {
          if(this.featureList.find(x => x.featureCode === Enums.FeatureCode.INVGN)?.isActive 
                 && this.userService?.currentUserValue?.userRoleMenuDetails?.find(x=>x.moduleId === Enums.ModuleNames.AllowInvoiceFeature)?.canView){
                  this.isGenerateInvocie = true;
          }
        }
      }
    }
  }
  public async onRefresh() {

    this.IsLockedByOtherUser();
    await this.onGetAppointmentDetails();
    if (this.editAppointmentService.checkInURL && this.editAppointmentService.appointmentDetails.bookedDate != null && this.editAppointmentService.appointmentDetails.bookedDateTime) {
      this.appLinkService.GetTrackerLink(this.appointmentDetails.appointmentGuid).then(x => {
        this.editAppointmentService.trackerURL = x;
      }).finally(() => { this.spinner.hide(); });
    }
    await this.commonService.getComments(this.commonService.appointmentDetails.appointmentId);
    this.workorderService.isDisableSaveButton = false;
    this.loadErrorMessage();
  }

  SelectTab(tab: any) {
    this.selectedtab = tab.id;
  }

  private getDismissDeleteReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }

  OpenAlertPopUp(cause: any, isDmsSyncingRelated) {
    let modelHeadermsg = isDmsSyncingRelated ? this.translate.instant("lblSyncToDMS") : this.translate.instant("lblUnsavedDetails");
    let modelBodymsg = isDmsSyncingRelated ? this.translate.instant("lblSureToSyncAppointmentData") : this.translate.instant("lblSureToUpdateAppointmentData");

    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {  // This is intentional
    }, (reason) => {
      let popupCloseResult = this.getDismissDeleteReason(reason);
      if (popupCloseResult) {
        this.child.SaveAppointmentData();
        this.SelectTab(cause)
        if (cause == 'close') {
          this.OnClose()
        }
      }
      else {
        if (cause == 'close') {
          this.OnClose()
        }
        else {
          this.SelectTab(cause)
        }
      }
    });
  }


  async onGetAppointmentDetails() {
    const id = this.editAppointmentService.appointmentDetails.id;
    const languageCode = this.cookieservice.get('userSelectedLanguage');
    this.spinner.show();

    await this.appointmentService.GetAppointmentDetail(id, languageCode).then((res) => {
      if (res.responseObject?.errorCount == Constant.ValidationFailure) {
        let msg = this.translate.instant("lblAppointmentDeleted");
        this.toastr.error(msg);
        this.spinner.hide();
        return;
      }
      if (res.responseCode === Enums.ErrorCodes.SuccessCode
        && !(res.responseObject?.errorCount > 0)) {
          this.cdr.detectChanges();
        this.editAppointmentService.appointmentDetails = this.AppointmentDataMapper(res.responseObject, id);
        this.commonService.appointmentDetails = this.commonService.AppointmentDataMapper(this.editAppointmentService.appointmentDetails);
        //from this.ngOnInit
        this.appointmentDetails = this.editAppointmentService.appointmentDetails;
        if (this.appointmentDetails.appointmentStatusId === AppointmentStatus.InvoiceReady || this.appointmentDetails.appointmentStatusId === AppointmentStatus.Closed) {
          this.condition = true;
        }
        else {
          let feature = FeatureCode.DWO + "," + FeatureCode.SSM + "," + FeatureCode.TecRMI + "," + FeatureCode.Romnas + "," + FeatureCode.Scrive + "," + FeatureCode.WhatsApp;
          this.roleRightsService.getFeatureByDealerId(feature, this.appointmentDetails.dealerId, this.appointmentDetails.brandCode).then((res) => {
            if (res.responseObject?.result) {
              this.features = res.responseObject?.result;
              if (this.features && this.features.length > 0) {
                let SSMFeature = this.features.find(x => x.featureCode === FeatureCode.SSM)
                this.editAppointmentService.isSSMEnabled = (SSMFeature != null || SSMFeature != undefined) ? true : false;
                let tecRMIFeature = this.features.find(x => x.featureCode === FeatureCode.TecRMI)
                this.editAppointmentService.isTecRMIEnabled = (tecRMIFeature != null || tecRMIFeature != undefined) ? true : false;
                let dsoFeature = this.features.find(x => x.featureCode === FeatureCode.DWO)
                this.isDsoActive = (dsoFeature != null || dsoFeature != undefined) ? true : false;
                let whatsappFeature = this.features.find(x => x.featureCode === FeatureCode.WhatsApp)
                this.isWhatsappActive = (whatsappFeature != null || whatsappFeature != undefined) ? true : false;
                let scriveFeature = this.features.find(x => x.featureCode === FeatureCode.Scrive)
                this.isScriveActive = (scriveFeature != null || scriveFeature != undefined) ? true : false;
                let romnasFeature = this.features.find(x => x.featureCode === FeatureCode.Romnas)
                this.editAppointmentService.isRomnasEnabled = (romnasFeature != null || romnasFeature != undefined) ? true : false;
              }
            }
          })
        }
        this.setPdfToolTipBasedOnWorkOrderStatus();
        this.editAppointmentService.selectedMainTabNumber = this.selectedtab;
        if (this.selectedtab == 1) {
          this.child.ngOnInit();
        }
        else if (this.selectedtab == 2) {
          this.childAppointmentAdditionalWorkComponent.ngOnInit();
        }
        else if (this.selectedtab == 3) {
          this.childAppointmentPlanningComponent.ngOnInit();
        }
        else if (this.selectedtab == 4) {
          this.editAppointmentService.selectedChildTabNumber = this.childAppointmentDWOComponent.selectedDWOTab;
          this.childAppointmentDWOComponent.ngOnInit();
        }
        else if (this.selectedtab == 5) {
          this.childAppointmentCommunicationComponent.ngOnInit();
        }
        else if (this.selectedtab == 6) {
          this.childAppointmentParkingComponent.ngOnInit();
        }
        else if (this.selectedtab == 7) {
          this.childAppointmentWorkOrderHistoryComponent.ngOnInit();
        }
        else if (this.selectedtab == 8) {
          this.childAppointmentDocumentComponent.ngOnInit();
        }
        else if (this.selectedtab == 9) {
          this.chileAppointmentInvoiceComponent.ngOnInit();
        }
        else if (this.selectedtab == 10) {
          this.childAppointmentHistoryComponent.ngOnInit();
        }
        else if (this.selectedtab == 11) {
          this.chileWhatsAppMessagesComponent.ngOnInit();
        }
        else if(this.selectedtab==12){
          this.childShareboxLogComponent.ngOnInit();
        }
        this.spinner.hide();
      }
      this.spinner.hide();
    });
  }
  empty(e: any) {
    switch (e) {
      case "":
      case null:
      case undefined:
        return true;
      default:
        return false;
    }
  }
  private AppointmentDataMapper(appointment: any, id) {
    let single = Object();
    single = appointment;
    single.id = id;
    single.licensePlate = appointment.licensePlate;
    single.customerName = appointment.customerName;
    single.mobileNo = appointment.mobileNo;
    single.mobileCode = appointment.mobileCode;
    single.dealerName = appointment.dealerName;
    single.appointmentStatusColor = appointment.appointmentStatusColor;
    single.brand = null;
    single.dealerId = appointment.dealerId;
    single.modelName = appointment.modelName;
    single.brandCode = appointment.brandCode;
    single.brandName = appointment.brandName;
    single.workOrderNo = appointment.workOrderNo;
    single.workOrderStatus = appointment.workorderStatus;
    single.workOrderStatusId = appointment.workorderStatusId;
    single.workOrderStatusColor = appointment.workorderStatusColor;
    single.appointmentStatusId = appointment.appointmentStatusId;
    single.bookedDate = appointment.bookedDate;
    single.createdDate = appointment.createdDate;
    single.createdDateTime = appointment.createdDateTime ? new Date(appointment.createdDateTime + 'Z') : null;
    single.bookedDateTime = appointment.bookedDateTime;
    single.isEditable = this.getEditStatusofAppointment(appointment);
    single.isDeletable = this.getDeleteStatusofAppointment(appointment);
    single.appointmentType = appointment.appointmentType;
    single.appointmentGuid = appointment.appointmentGuid;
    single.createdTime = appointment.createdTime;
    single.appointmentStatus = appointment.appointmentStatus;
    single.isBookingAllowed = appointment.isBookingAllowed;
    single.sourceCreation = appointment.sourceCreation;
    single.unitPrice = appointment.unitPrice;
    single.chassisNo = appointment.chassisNo;
    single.totalCount = appointment.totalCount;
    single.isRentalCarRequired = appointment.isRentalCarRequired;
    single.isCustomerWaiting = appointment.isCustomerWaiting;
    single.dmsSyncStatus = appointment.dmsSyncStatus
    single.dmsSyncDate = appointment.dmsSyncDate ? new Date(appointment.dmsSyncDate + 'Z') : null;
    single.documentPartStatus = appointment.documentPartStatus;
    single.isFromArchive = this.isOpenFromPlanning ? true : appointment.isFromArchive;
    single.remark = appointment.remark;
    single.information = appointment.information;
    single.invoiceReference = appointment.invoiceReference;
    single.discountCode = appointment.discountCode;
    single.isMpoOfferCreated = appointment.isMpoOfferCreated;
    single.mpoOfferNo = appointment.mpoOfferNo;
    single.mpoUrl = appointment.mpoUrl;
    single.isOpenAppointment = appointment.isOpenAppointment;

    return single;
  }
  getEditStatusofAppointment(appointment: any) {
    let canEdit = false;
    if (this.appointmentService.appointmentStatusList && this.appointmentService.appointmentStatusList.length > 0) {
      let editable = this.appointmentService.appointmentStatusList.find(x => x.id === appointment.workorderStatusId);
      if ((appointment.appointmentType === Enums.AppointmentType.OFFER && appointment.isQuoteExipred) || this.editAppointmentService.isOpenByOtherUser) {
        return canEdit;
      }
      else if (editable?.isEditable) {
        canEdit = this.isOpenFromPlanning ? false: (this.editAppointmentService.appointmentDetails.isFromArchive ? false : (this.isViewAppointmentFromWAR? false : true));
        this.editAppointmentService.isEdit = canEdit;
      }
    }
    return canEdit;
  }
  getDeleteStatusofAppointment(appointment: any) {
    let canDelete = false;
    if (this.appointmentService.appointmentStatusList && this.appointmentService.appointmentStatusList.length > 0) {
      let deletable = this.appointmentService.appointmentStatusList.find(x => x.id === appointment.workorderStatusId);
      if (deletable?.isDeletable) {
        canDelete = deletable.isDeletable;
      }
    }
    return canDelete;
  }

  exportSSM() {
    this.spinner.show()
    this.SSMservice.ExportSSM(this.appointmentDetails.id.toString(), this.appointmentDetails.dealerId, this.appointmentDetails.brandName).then((res) => {
      if (res) {
        if (res?.errorMessage) {
          if (res?.errorCode === 5) {
            this.editAppointmentService.exportedJson = res.exportedJson;
            this.editAppointmentService.isExported = true;
            this.child.SaveAppointmentData();
          }
          else {
            let msg = this.translate.instant(res?.errorMessage)
            this.toastr.error(msg)
            this.spinner.hide();
          }

        }
      }
    })
  }
  deleteFromSSM() {
    this.spinner.show()
    this.SSMservice.DeleteSSM(this.appointmentDetails.workOrderNo, this.appointmentDetails.dealerId).then((res) => {
      if (res) {
        if (res?.errorMessage) {
          this.toastr.success(res?.errorMessage)
        }
      }
    })
    this.spinner.hide();
  }
  importSSM() {
    this.spinner.show()
    let model = this.CreateImportSSMModel();
    this.SSMservice.ImportSSM(model).then((res) => {
      if (res) {
        if (res?.errorCode === 6) {
          let msg = this.translate.instant(res?.errorMessage)
          this.toastr.success(msg)
        }
        if (res?.errorCode === 1 || res?.errorCode === 2) {
          let msg = this.translate.instant(res?.errorMessage)
          this.toastr.error(msg)
        }
        if (res?.errorCode === 7) {
          let msg = this.translate.instant(res?.errorMessage)
          this.toastr.warning(msg)
        }
      }

    })
    this.spinner.hide();
  }
  CreateImportSSMModel(): SSMRequestModel {
    let vehicles = [];
    let vehicle = {
      vin: this.appointmentDetails.chassisNo,
      registration: this.appointmentDetails.licensePlate,
      brand: this.appointmentDetails.brandName,
    }
    vehicles.push(vehicle);
    return {
      externalId: this.appointmentDetails.id.toString(),
      type: "",
      dealerId: "",
      userId: "",
      vehicles: vehicles,
      appointmentDealerId: this.appointmentDetails.dealerId
    }
  }

  getRomnasAutoLoginUrl() {
    this.spinner.show()
    let model = {
      LicensePlate: this.appointmentDetails.licensePlate,
      DealerId: this.appointmentDetails.dealerId,
    };
    this.romnasService.GetRomnasAutoLoginUrl(model).then((res) => {
      if (res) {
        if (res?.errorCode === 1) {
          this.spinner.hide();
          this.toastr.error(Enums.ToastrMessages.UnAuthorizedError);
        }
        else {
          this.spinner.hide();
          const url = res.url;
          window.open(url, '_blank');
        }

      }
    })
    this.spinner.hide();
  }

  importRomnasBasket() {
    this.spinner.show()
    let model = {
      WoNo: this.appointmentDetails.workOrderNo,
      DealerId: this.appointmentDetails.dealerId,
    };
    this.romnasService.ImportRomnasBasket(model).then((res) => {
      if (res) {
        if (res?.errorCode === 0) {
          this.editAppointmentService.exportedJson = res.exportedJson;
          this.editAppointmentService.isExported = true;
          this.child.SaveAppointmentData().then((sresp) => {
          }).finally(() => {
            this.spinner.hide();
          });
          this.deleteFromRomnas();
        }
        else {
          let msg = this.translate.instant(res?.errorMessage)
          this.toastr.error(msg)
          this.spinner.hide();
        }
      }
    })
  }
  deleteFromRomnas() {
    this.romnasService.DeleteRomnas().then((res) => {
      if (res) {
        if (res?.errorMessage) {
          this.toastr.success(res?.errorMessage)
        }
      }
    })
  }

  OpenPdfModel(e: boolean): void {
    if(this.editAppointmentService.appointmentDemandList == null || this.editAppointmentService.appointmentDemandList.length == 0){
      let msg = this.translate.instant("lblNoServicesAddedToGenerateOrder");
      this.toastr.warning(msg);
      return;
    }
    else{
      const modalref = this.modalService.open(PDFAppointmentOrderComponent, { size: 'lg', windowClass: 'pop-wid1800' });
      modalref.componentInstance.isDownloadOrder = e;
    }
  }

  OpenSendNotificationModel(): void {
    const modalref = this.modalService.open(SendNotificationComponent, { size: 'lg', windowClass: 'pop-wid1200' });
    modalref.componentInstance.appointmentId = this.appointmentDetails.id;
    modalref.componentInstance.dealerId = this.appointmentDetails.dealerId;
    modalref.componentInstance.isForApprovalORRejection = 0;
  }

  copyCheckInLink() {
    this.clipboardApi.copyFromContent(this.editAppointmentService.checkInURL)
  }
  copyTrackerLink() {
    this.clipboardApi.copyFromContent(this.editAppointmentService.trackerURL)
  }

  ngOnDestroy(): void {
    this.updatedModalRef = null;
    this.commonService.isSaveAndClose = false;
    this.commonService.SelectedStatus = null;
  }
  OnClose() {
    this.activeModal.close({
      success: false
    });
    if(!this.commonService.isPopupClose){
      this.commonService.contactDetails = null;
    }
    this.commonService.isSaveAndClose = false;
  }

  CheckDataSynced(cause: any) {
    if(this.commonService.isSaveAndClose){
      this.OnClose();
    }
    else{
    this.featureList = this.secureStorage.getKeyData('feature');
    if (this.featureList && this.featureList.length > 0) {
      this.isDMSEnable = this.featureList.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive;
      this.isDmsPackageSync = this.featureList.find(x => x.featureCode === Enums.FeatureCode.DmsPackageSync)?.isActive;
    }
    if (this.selectedtab == 1 && this.editAppointmentService.appointmentDetails.appointmentType == Enums.AppointmentType.ORDER && !this.editAppointmentService.appointmentDetails.isFromArchive) {
      let showAlert = false;
      let isDmsSyncingRelated = false;
      if (this.isDMSEnable && this.isDmsPackageSync) {
        if (this.workorderService?.appointmentJobDetailList?.length > 0) {
          let notSyncedJobDetail = this.workorderService?.appointmentJobDetailList?.filter(x => x.dmsLineNo == '' || x.dmsLineNo == undefined || x.dmsLineNo == null);
          if (notSyncedJobDetail?.length > 0) {
            showAlert = true;
          }
        }
        if (this.workorderService?.appointmentJobDetailToUpdate?.length > 0) {
          let notSyncedJobDetail = this.workorderService?.appointmentJobDetailToUpdate?.filter(x => x.dmsLineNo == '' || x.dmsLineNo == undefined || x.dmsLineNo == null);
          if (notSyncedJobDetail?.length > 0) {
            showAlert = true;
          }
        }
        isDmsSyncingRelated = true;
        //if found any unsync details then display only data syncing message like current scanario. if not found then check other details modify changes. and 
        //Show other details not saved message.
        if (!showAlert) {
          isDmsSyncingRelated = false;
          //Check if any details has been modified.
          showAlert = this.checkUnsavedDetails();
        }
      } else {
        //Check if any details has been modified.
        isDmsSyncingRelated = false;
        showAlert = this.checkUnsavedDetails();
      }

      if (showAlert) {
        this.OpenAlertPopUp(cause, isDmsSyncingRelated);
      }
      else {
        if (cause == 'close') {
          this.OnClose();
        }
        else {
          this.SelectTab(cause);
        }
      }
    }
    else {
      if (cause == 'close') {
        this.OnClose();
      }
      else {
        this.SelectTab(cause);
      }
    }
  }
  }

  checkUnsavedDetails() {
    let showAlert = false;
    //get modified fields object
    const viewModel = this.workorderService.MapToViewModel(true, false);
    //this.appointmentDetails
    if (this.editAppointmentService.appointmentDetails.kilometer != this.contactDetails.kilometer) { //for integer use != and for string use !==
      showAlert = true;
    } else if (this.editAppointmentService.appointmentDetails.workOrderStatusId != this.contactDetails.workorderStatusId) {
      showAlert = true;
    } else if (this.editAppointmentService.appointmentDetails.contactInfo !== this.contactDetails.contactInfo) {
      showAlert = true;
    } else if (this.editAppointmentService.appointmentDetails.singlePhoneNo !== this.contactDetails.singlePhoneNo) {
      showAlert = true;
    } else if (this.editAppointmentService.appointmentDetails.paymentMethodCode !== this.contactDetails.paymentMethodCode) {
      showAlert = true;
    } else if (this.editAppointmentService.appointmentDetails.paymentTermsCode !== this.contactDetails.paymentTermsCode) {
      showAlert = true;
    } else if (this.editAppointmentService.appointmentDetails.information !== this.contactDetails.information) {
      showAlert = true;
    } else if (this.editAppointmentService.appointmentDetails.invoiceReference !== this.contactDetails.invoiceReference) {
      showAlert = true;
    }else if (this.editAppointmentService.appointmentDetails.documentPartStatus !== this.contactDetails.documentPartStatus) {
      showAlert = true;
    } else if (this.editAppointmentService.appointmentDetails.isCustomerWaiting !== this.contactDetails.isCustomerWaiting) {
      showAlert = true;
    } else if (((this.editAppointmentService.appointmentDetails.rentalVehicleId == null || !this.editAppointmentService.appointmentDetails.isRentalCarSelected) ? 0 : this.editAppointmentService.appointmentDetails.rentalVehicleId) != ((this.contactDetails.rentalVehicleId == null || !this.contactDetails.isRentalCarSelected) ? 0 : this.contactDetails.rentalVehicleId)) {
      showAlert = true;
    } else if (this.editAppointmentService.appointmentDetails.isRentalCarSelected !== this.contactDetails.isRentalCarSelected) {
      showAlert = true;
    } else if (this.editAppointmentService.appointmentDetails.isKeyDrop !== this.contactDetails.isKeyDrop) {
      showAlert = true;
    } else if (this.editAppointmentService.appointmentDetails.isAutoKey !== this.contactDetails.isAutoKey) {
      showAlert = true;
    } else if (this.editAppointmentService.appointmentDetails.isCheckIn !== this.contactDetails.isCheckIn) {
      showAlert = true;
    }else if (this.editAppointmentService.appointmentDetails.importedCar !== this.contactDetails.importedCar) {
      showAlert = true;
    }else if (this.editAppointmentService.appointmentDetails.campaignService !== this.contactDetails.campaignService) {
      showAlert = true;
    }else if (this.editAppointmentService.appointmentDetails.toweinCars !== this.contactDetails.toweinCars) {
      showAlert = true;
    }else if ((!this.empty(this.editAppointmentService.appointmentDetails.deliveryTime) ? 
      Utility.GetFormattedDate(this.editAppointmentService.appointmentDetails.deliveryTime) : '')
      !== 
      (!this.empty(this.contactDetails.deliveryTime) ? Utility.GetFormattedDate(this.contactDetails.deliveryTime) : '')) {
        showAlert = true;
    } else if ((!this.empty(this.editAppointmentService.appointmentDetails.finishedTime) ? 
      Utility.GetFormattedDate(this.editAppointmentService.appointmentDetails.finishedTime) : '')
      !== 
      (!this.empty(this.contactDetails.finishedTime) ? Utility.GetFormattedDate(this.contactDetails.finishedTime) : '')) {
        showAlert = true;
    }
    else if ((!this.empty(this.editAppointmentService.appointmentDetails.deliveryTime) ? 
      Utility.ConvertUTCDateToLocalTime(this.editAppointmentService.appointmentDetails.deliveryTime) : '')
      !== 
      (!this.empty(this.contactDetails.deliveryTime) ? Utility.ConvertUTCDateToLocalTime(this.contactDetails.deliveryTime) : '')) {
        showAlert = true;
    }
    else if ((!this.empty(this.editAppointmentService.appointmentDetails.finishedTime) ? 
      Utility.ConvertUTCDateToLocalTime(this.editAppointmentService.appointmentDetails.finishedTime) : '')
      !== 
      (!this.empty(this.contactDetails.finishedTime) ? Utility.ConvertUTCDateToLocalTime(this.contactDetails.finishedTime) : '')) {
        showAlert = true;
    }
    else if (this.workorderService.appointmentDemandList.length > 0) {
      this.workorderService.appointmentDemandList.forEach((demand) => {
        let data: any = this.editAppointmentService.appointmentDemandList.filter
          (x => x.demandNo == demand.demandNo &&
            (x.customerRequirement != demand.customerRequirement ||
              x.shortDescription != demand.shortDescription ||
              x.sentForCustomerApproval != demand.sentForCustomerApproval ||
              x.isHidePrice != demand.isHidePrice ||
              x.isInWarranty != demand.isInWarranty ||
              x.billToCustomer != demand.billToCustomer ||
              x.fixedPrice != demand.fixedPrice))
        if (data?.length > 0) {
          showAlert = true;
        }
      })

      this.workorderService.appointmentJobDetailList.forEach((job) => {
        let data: any = this.editAppointmentService.appointmentJobDetailsList.filter
          (x => x.id == job.id &&
            (x.description != job.description ||
              x.plannedQuantity != job.plannedQuantity ||
              x.discount != job.discount))
        if (data?.length > 0) {
          showAlert = true;
        }
      })
    }
    return showAlert;
  }

  onTechRmiMaintenance() {
    const modalref = this.modalService.open(TecRmiPopupComponent, { size: 'lg', windowClass: 'pop-wid1200 pop-hig500' });
    modalref.componentInstance.contactDetails = this.contactDetails;
    modalref.result.then(
      (_result) => {
        this.child.SaveAppointmentData();
        this.ngOnInit();
      },
      (_reason) => {
      }
    );
  }

  onTechRmiLabour() {
    const modalref = this.modalService.open(TecRmiLabourPopupComponent, { size: 'lg', windowClass: 'pop-wid1200 pop-hig500' });
    modalref.componentInstance.contactDetails = this.contactDetails;
    modalref.result.then(
      (_result) => {
        this.child.SaveAppointmentData();
        this.ngOnInit();
      },
      (_reason) => {
      }
    );
  }

  //#region Edit Appointment Notification
  IsLockedByOtherUser() {
    if (this.editAppointmentService.isLockFeatureEnabled) {
      const appointment = this.editAppointmentService.appointmentDetails;
      if (appointment.appointmentGuid) {
        this.appointmentService.IsLockedByOtherUser(appointment.appointmentGuid).then((res) => {
          const locked = res.responseObject;
          if (locked?.isLocked) {
            let msg = this.translate.instant('lblUsedByAnotherUser');
            msg = msg.replace('##USER##', locked.lockedByName);
            this.editAppointmentService.isOpenByOtherUser = true;
            this.editAppointmentService.isEdit = false;
            this.isOpenByOtherUserMsg = msg;
          }
          else {
            this.globalSetting.InitEditByOtherConfig(appointment);
            this.editAppointmentService.isOpenByOtherUser = false;
            this.editAppointmentService.isEdit = this.getEditStatusofAppointment(appointment);
          }
        });
      }
    }
    else {
      this.editAppointmentService.isOpenByOtherUser = false;
    }
  }

  onDelete() {
    this.spinner.show();
    this.appointmentService.IsLockedByOtherUser(this.editAppointmentService.appointmentDetails.appointmentGuid).then((res) => {
      const locked = res.responseObject;
      if (locked?.isLocked && this.editAppointmentService.isLockFeatureEnabled) {
        let modelHeadermsg = this.translate.instant('lblAppointmentLocked');
        let modelBodymsg = this.translate.instant('lblUsedByAnotherUser');
        modelBodymsg = modelBodymsg.replace('##USER##', locked.lockedByName);
        this.editAppointmentService.isOpenByOtherUser = true;
        const updatedModalRef = this.modalService.open(NgInfoModalContent);
        updatedModalRef.componentInstance.modelHeader = modelHeadermsg;
        updatedModalRef.componentInstance.modelBody = modelBodymsg;
      } else {
        this.editAppointmentService.isOpenByOtherUser = false;
        let modelHeadermsg = this.translate.instant("lblDelete");
        let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"), this.translate.instant("lblAppointment"), true);
        const modalRef = this.modalService.open(NgbdModalContent);
        modalRef.componentInstance.modelHeader = modelHeadermsg;
        modalRef.componentInstance.modelBody = modelBodymsg;
        modalRef.result.then((_result) => {
          // This is intentional
        }, (reason) => {
          let popupCloseResult = this.getDismissDeleteReason(reason);
          if (popupCloseResult) {
            this.featureList = this.secureStorage.getKeyData('feature');
            let isDeleteDmsAppointment = false;
            if (this.featureList && this.featureList.length > 0) {
              isDeleteDmsAppointment = this.featureList.find(x => x.featureCode === Enums.FeatureCode.DeleteDmsAppointment)?.isActive;
            }

            const modalref = this.modalService.open(DeleteWorkorderComponent,
              { size: 'lg', windowClass: 'pop-wid800 ' });
            modalref.componentInstance.licensePlate = this.editAppointmentService.appointmentDetails.licensePlate;
            modalref.componentInstance.appointmentId = this.editAppointmentService.appointmentDetails.id;
            modalref.componentInstance.workOrderNumber = this.editAppointmentService.appointmentDetails.workOrderNo;
            modalref.componentInstance.isDeleteFromDms = isDeleteDmsAppointment;
            modalref.componentInstance.appointmentGuid = this.editAppointmentService.appointmentDetails.appointmentGuid;

            modalref.result.then((response) => {
              //status update
              this.spinner.hide();
              if (response.success) {
                this.appointmentService.isRefreshListing = true;
                this.activeModal.close({
                  success: true
                });
              }
            }, _error => {
              this.spinner.hide();
              // This is intentional
            });
          }
        });
      }
    }).finally(() => {
      this.spinner.hide();
    });
  }

  onInvoice() {
    const modalref = this.modalService.open(InvoiceWarningPopupComponent,
      { size: 'lg', windowClass: 'pop-wid1200 ' });
    modalref.componentInstance.appointmentDetails = this.editAppointmentService.appointmentDetails;

    modalref.result.then((response) => {
      //status update
      this.spinner.hide();
      if (response.success) {
        this.onRefresh();
      }
      this.selectedtab = 9;
      this.chileAppointmentInvoiceComponent.ngOnInit();
    }, _error => {
      this.spinner.hide();
      this.selectedtab = 9;
      this.chileAppointmentInvoiceComponent.ngOnInit();
      // This is intentional
    });
  }

  templateLegendResponseModel: TemplateLegendResponseModel = { item1: '', item2: '' }
  isAppointmentCofirmationOpen = false;
  async onAppointmentCofirmation(viewPreView: any) {
    if (this.isAppointmentCofirmationOpen) return;
    const requestModel = {
      AppointmentId: this.editAppointmentService.appointmentDetails.isFromArchive ? 0 : this.appointmentId,
      ArchiveAppointmentId : this.editAppointmentService.appointmentDetails.isFromArchive ? this.appointmentId : 0,
      LanguageCode: this.cookieservice.get('userSelectedLanguage'),
      DealerId: this.editAppointmentService.appointmentDetails.dealerId,
      TemplateScope: TemplateScope.Appointment
    }
    this.confirmAppointmentEmail = this.editAppointmentService.appointmentDetails.email;
    this.isAppointmentCofirmationOpen = true;
    await this.appointmentService.getManualNotificationData(requestModel).then(result => {
      this.templateLegendResponseModel = result.responseObject;
      this.modalService.open(viewPreView, { ariaLabelledBy: 'modal-basic-title', size: 'lg', backdrop: 'static' }).result.then((result) => {
        this.isAppointmentCofirmationOpen = false;
        });
           // Wait for modal to be fully initialized before applying draggable
           setTimeout(() => {
            this.makeLatestModalDraggable();
            this.bindPreviewActions();
          }, 100);
    });
  }

  SendNotification() {
    this.templateLegendResponseModel.item2 =
    this.removeEditorOnlyElements(this.templateLegendResponseModel.item2);
    let sendNotificationModel: ManualNotificationRequestModel = {
      body: this.templateLegendResponseModel.item2,
      subject: this.templateLegendResponseModel.item1,
      templateCode: 122,
      templateType: 1,
      actionCode: 122,
      dealerId: this.editAppointmentService.appointmentDetails.dealerId,
      languageCode: this.cookieservice.get('userSelectedLanguage'),
      appointmentId: this.editAppointmentService.appointmentDetails.isFromArchive ? 0 : this.editAppointmentService.appointmentDetails.id,
      archiveAppointmentId: this.editAppointmentService.appointmentDetails.isFromArchive ? this.editAppointmentService.appointmentDetails.id : 0,
      appointmentGuid: this.editAppointmentService.appointmentDetails.appointmentGuid,
      applicationId: 0,
      cultureCode: '',
      customerId: 0,
      isAddNotification: false,
      loginUserId: '',
      roleId: 0,
      mechanicId: 0,
      isBasic: false,
      workOrderNo: this.editAppointmentService.appointmentDetails.workOrderNo,
      recipientList: []
    }
    let recipient: ManualNotificationRecipientList = {
      fromEmail: '',
      toEmail: this.confirmAppointmentEmail,
      userId: '',
      deviceId: '',
      fromMobileCode: '',
      fromMobileNo: '',
      toMobileCode: '',
      toMobileNo: ''
    }
    sendNotificationModel.recipientList.push(recipient);
    this.spinner.show();
    this.dealerDataService.SendNotification(sendNotificationModel).then((res) => {
      if (res.responseObject === true) {
        let msg = this.translate.instant("lblNotificationSend");
        this.toastr.success(msg);
      }
      else {
        let msg = this.translate.instant("lblNotificationSendFailedMsg");
        this.toastr.error(msg);
      }
    }).finally(() => {
      this.spinner.hide()
    });
  }
  SendSharBoxInformation() {
    let modelHeadermsg = this.translate.instant("lblSentShareBoxInformation");
    let modelBodymsg = this.translate.instant("lblSureWantToShareShareBoxInformation");
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {
      // This is intentional
    }, (reason) => {
      if(reason){
        this.spinner.show();
        let customerNo = '+' + this.editAppointmentService.appointmentDetails?.billToCustomerMobileCode + this.editAppointmentService.appointmentDetails?.billToMobile
        this.notificationService.sentShareboxInformation(this.appointmentDetails.dealerId, this.editAppointmentService.appointmentDetails.id, this.selectedLanguage, customerNo).then((res) => {
          if (res.responseMessage?.length === 0 || res.responseMessage === null) {
            this.toastr.success(this.translate.instant("lblShareBoxInformationShared"))
            this.onRefresh();
          }
          else {
            this.toastr.error(this.translate.instant("lblShareBoxInformationNotSent"))
          }
        }).finally(() => {
          this.spinner.hide();
        });
      }
    });
  }
  GetMpoOffer(){
    this.spinner.show();
    let viewModel = {
      DealerId: this.editAppointmentService.appointmentDetails.dealerId,
      AppointmentId: this.editAppointmentService.appointmentDetails.id,
      UserId: '',
      VinNumber: this.editAppointmentService.appointmentDetails.chassisNo,
      Brand: this.editAppointmentService.appointmentDetails.brandCode,
      OfferId: this.editAppointmentService.appointmentDetails.mpoOfferNo
    }
    this.mpoService.GetOffer(viewModel).then((res) => {
      if (res) {
        if(res && res?.statusCode == 1 && res?.responseMessage?.length > 0){
          this.toastr.success(this.translate.instant("lblOfferImported"))
          this.editAppointmentService.isFromMpo = true;
            this.editAppointmentService.exportedMpoData = res?.responseMessage;
            this.child.SaveAppointmentData();
         }
         else if(res && res?.statusCode == 3){
          this.toastr.warning(this.translate.instant("lblOfferNotExists"));
        }
        else{
          this.toastr.error(this.translate.instant("lblInternalError"));
        }
      }
    }).finally(()=>{
      this.spinner.hide();
    })
  }
  CreateOfferInMpo(){
    this.spinner.show()
    let viewModel = {
      DealerId: this.editAppointmentService.appointmentDetails.dealerId,
      AppointmentId: this.editAppointmentService.appointmentDetails.id,
      UserId: '',
      VinNumber: this.editAppointmentService.appointmentDetails.chassisNo,
      Brand: this.editAppointmentService.appointmentDetails.brandCode
    }
    this.mpoService.CreateOffer(viewModel).then((res) => {
       if(res && res?.statusCode == 1 && res?.offerId?.length > 0){
        this.toastr.success(this.translate.instant("lblOfferCreated"))
        this.editAppointmentService.appointmentDetails.mpoOfferNo = res?.offerId;
        this.editAppointmentService.appointmentDetails.mpoUrl = res?.urlMpo
       }
       else if(res && res?.statusCode == 3)
        {
          this.toastr.warning(this.translate.instant("lblOfferIsAlreadyCreated"));
        }
      else{
        this.toastr.error(this.translate.instant("lblOfferIsNotCreated"));
      }
    }).finally(()=>{
      this.spinner.hide();
    })
  }

  makeLatestModalDraggable() {
    // Select the most recently opened modal
    const modalWindows = document.querySelectorAll('.modal-dialog');
    if (modalWindows.length === 0) return;

    const latestModal = modalWindows[modalWindows.length - 1] as HTMLElement; // Get last opened modal
    const modalHeader = latestModal.querySelector('.modal-header') as HTMLElement;

    if (!latestModal || !modalHeader) {
      console.error('Modal elements not found');
      return;
    }

    let isDragging = false;
    let startX = 0, startY = 0, initialX = 0, initialY = 0;

    modalHeader.style.cursor = 'move';

    modalHeader.onmousedown = (e) => {
      isDragging = true;
      startX = e.clientX;
      startY = e.clientY;

      const rect = latestModal.getBoundingClientRect();
      initialX = rect.left;
      initialY = rect.top;

      document.onmousemove = (event) => {
        if (isDragging) {
          const dx = event.clientX - startX;
          const dy = event.clientY - startY;
          latestModal.style.position = 'absolute';
          latestModal.style.left = `${initialX + dx}px`;
          latestModal.style.top = `${initialY + dy}px`;
          latestModal.style.margin = '0'; // Prevents Bootstrap centering issue
        }
      };

      document.onmouseup = () => {
        isDragging = false;
        document.onmousemove = null;
        document.onmouseup = null;
      };
    };
  }

  async syncDemandToSST(){
    this.spinner.show();
    await this.appointmentService.syncDemandToSST(this.editAppointmentService.appointmentDetails.appointmentGuid,this.editAppointmentService.appointmentDetails.id).then(result => {
      if(result.responseObject.result.errorCode == Enums.ErrorCodes.SuccessCode)
      {
        let msg = this.translate.instant(result.responseObject.result.errorMessage);
        this.toastr.success(msg);
        this.spinner.hide();
      }
      else if(result.responseObject.result.errorCode == Enums.ErrorCodes.NotFound)
      {
        let msg = this.translate.instant(result.responseObject.result.errorMessage);
        this.toastr.warning(msg);
        this.spinner.hide();
      }
      else{
        let msg = this.translate.instant(result.responseObject.result.errorMessage);
        this.toastr.error(msg);
        this.spinner.hide();
      }
    });
  }

  addServiceRow() {
    if (!this.quillInstance) return;

    const root = this.quillInstance.root as HTMLElement;
    const serviceTable = root.querySelector('#service');

    if (!serviceTable) return;

    const cells = Array.from(serviceTable.querySelectorAll('td[data-row]'));
    const maxRow = cells.reduce((max, td) => {
      const val = Number(td.getAttribute('data-row'));
      return isNaN(val) ? max : Math.max(max, val);
    }, 0);

    const nextRow = maxRow + 1;

    const tr = document.createElement('tr');
    tr.setAttribute('data-service-row', nextRow.toString());

    tr.innerHTML = `
      <td data-row="${nextRow}" contenteditable="true" style="padding: 2px 5px; vertical-align: top; font-weight: normal; width: 250px; font-size: 16px; min-height: 22px;"></td>
      <td data-row="${nextRow}" contenteditable="true" style="padding: 2px 5px; vertical-align: top; font-size: 16px; min-height: 22px; border-right:0;"></td>
      <td data-row="${nextRow}" style="width:40px; min-width: 40px; border-left:0; padding: 2px 5px; vertical-align: top; font-size: 16px; height: 22px; text-align: center;"><a class="btn btn-sm btn-danger delete-service-row" data-action="delete-service" data-row="${nextRow}" 
      style="border:0; padding: 0; font-size: 10px; border: none; color: #dc3545; background-color: transparent; font-size: 14px; text-decoration: none; cursor: pointer; border-radius: 3px; height: 20px; width: 20px;" title="Delete Row"><i class="fa fa-trash" aria-hidden="true"></i></a></td>`;

    const tbody = serviceTable.querySelector('tbody') || serviceTable;
    tbody.appendChild(tr);
    this.recalculateServiceTotal();
    this.bindDeleteEvents(); 
    this.quillInstance.update('user');
  }

  deleteServiceRow(rowNumber: number) {
    if (!this.quillInstance) return;

    const root = this.quillInstance.root as HTMLElement;
    const serviceTable = root.querySelector('#service');

    if (!serviceTable) return;

    const rowToDelete = serviceTable.querySelector(`tr[data-service-row="${rowNumber}"]`);
    if (rowToDelete) {
      rowToDelete.remove();
      this.recalculateServiceTotal();
      this.quillInstance.update('user');
    }
  }

  private _quillClickHandler: any;

  ngAfterViewInit() {
    setTimeout(() => {
      this.bindQuillActions();
      this.bindServiceTableEvents();
    }, 0);
  }

  bindQuillActions() {
    const quillInstance = this.emailQuillEditor?.quillEditor;
    if (!quillInstance) {
      console.warn('Quill instance not ready');
      return;
    }

    const editorEl = quillInstance.root; 

    editorEl.removeEventListener('click', this._quillClickHandler as any);
    this._quillClickHandler = (event: MouseEvent) => {
      const addTarget = (event.target as HTMLElement).closest('[data-action="add-service"]');
      const deleteTarget = (event.target as HTMLElement).closest('[data-action="delete-service"]');
      
      if (addTarget) {
        event.preventDefault();
        event.stopPropagation();
        this.addServiceRow();
      } else if (deleteTarget) {
        event.preventDefault();
        event.stopPropagation();
        const rowNumber = Number(deleteTarget.getAttribute('data-row'));
        this.deleteServiceRow(rowNumber);
      }
    };

    editorEl.addEventListener('click', this._quillClickHandler);
  }
  bindPreviewActions() {
    const previewContainer = document.querySelector('.modal-body');
    if (!previewContainer) return;

    previewContainer.addEventListener('click', (event: any) => {
      const addEl = event.target.closest('[data-action="add-service"]');
      const deleteEl = event.target.closest('[data-action="delete-service"]');
      
      if (addEl) {
        event.preventDefault();
        event.stopPropagation();
        this.addServiceRow();
      } else if (deleteEl) {
        event.preventDefault();
        event.stopPropagation();
        const rowNumber = Number(deleteEl.getAttribute('data-row'));
        this.deleteServiceRow(rowNumber);
      }
    });
  }
  onEditorCreated(quill: any) {
    this.quillInstance = quill;
    quill.on('text-change', () => {
      this.recalculateServiceTotal();
    });

    quill.root.addEventListener('click', (event: any) => {
      const target = event.target as HTMLElement;
      const action = target.getAttribute('data-action') || target.closest('[data-action]')?.getAttribute('data-action');

      if (action === 'add-service') {
        event.preventDefault();
        event.stopPropagation();
        this.addServiceRow();
      } else if (action === 'delete-service') {
        event.preventDefault();
        event.stopPropagation();
        const deleteButton = target.closest('[data-action="delete-service"]');
        const rowNumber = Number(deleteButton?.getAttribute('data-row'));
        this.deleteServiceRow(rowNumber);
      }
    });
  }

  onPreviewClick(event: MouseEvent) {
    const el = (event.target as HTMLElement).closest('[data-action="add-service"]');
    if (!el) return;

    this.addServiceRow();
  }

  bindDeleteEvents() {
    setTimeout(() => {
      const deleteButtons = document.querySelectorAll('.delete-service-row');
      deleteButtons.forEach(button => {
        button.addEventListener('click', (event: any) => {
          event.preventDefault();
          event.stopPropagation();
          const rowNumber = Number(button.getAttribute('data-row'));
          this.deleteServiceRow(rowNumber);
        });
      });
    }, 0);
  }

  private _serviceTableListener: any;

  bindServiceTableEvents() {
    setTimeout(() => {
      const table = document.querySelector('table#service');
      if (!table) return;

      if (this._serviceTableListener) {
        table.removeEventListener('input', this._serviceTableListener);
      }

      this._serviceTableListener = (event: any) => {
        if (
          event.target.classList.contains('service-price') ||
          event.target.getAttribute('contenteditable') === 'true'
        ) {
          this.updateTotalPrice();
        }
      };

      table.addEventListener('input', this._serviceTableListener);
    }, 0);
  }

  updateTotalPrice() {
    const html = this.emailQuillEditor?.quillEditor
      ? this.emailQuillEditor.quillEditor.root.innerHTML
      : this.templateLegendResponseModel.item2;

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const table = doc.querySelector('table#service');
    if (!table) return;

    let total = 0;
    table.querySelectorAll('.service-price').forEach((cell: any) => {
      let value = 0;
      if (cell.tagName === 'INPUT') {
        value = parseFloat(cell.value.replace(/[^\d.-]/g, '')) || 0;
      } else {
        value = parseFloat(cell.textContent.replace(/[^\d.-]/g, '')) || 0;
      }
      total += value;
    });

    const totalPriceCell = doc.querySelector('td[data-row][style*="font-weight: bold"] + td');
    if (totalPriceCell) {
      totalPriceCell.textContent = total ? total.toLocaleString() + ',-' : '0,-';
    }

    if (this.emailQuillEditor?.quillEditor) {
      this.emailQuillEditor.quillEditor.root.innerHTML = doc.body.innerHTML;
      this.templateLegendResponseModel.item2 = this.emailQuillEditor.quillEditor.root.innerHTML;
      this.bindServiceTableEvents(); 
    } else {
      this.templateLegendResponseModel.item2 = doc.body.innerHTML;
      this.bindServiceTableEvents();
    }
  }

  recalculateServiceTotal() {
    if (!this.quillInstance) return;

    const root = this.quillInstance.root as HTMLElement;
    const serviceTable = root.querySelector('#service');

    if (!serviceTable) return;

    let total = 0;
    const rows = serviceTable.querySelectorAll('tr');

    rows.forEach(row => {
      const cells = row.querySelectorAll('td');
      if (cells.length < 2) return;

      const priceText = cells[1].innerText;
      total += this.parsePrice(priceText);
    });

    const totalCell = root.querySelector('[data-total-price]');
    if (!totalCell) return;

    const formatted = this.decimalPipe.transform(total, '1.0-0')?.replace(',', ''); 
    totalCell.textContent = `${formatted},-`;

    this.quillInstance.update('user');
  }

  removeEditorOnlyElements(html: string): string {
    const wrapper = document.createElement('div');
    wrapper.innerHTML = html;

    wrapper.querySelectorAll('[data-action="add-service"]').forEach(el => {
      el.remove();
    });

    wrapper.querySelectorAll('[data-action="delete-service"]').forEach(el => {
      el.remove();
    });

    return wrapper.innerHTML;
  }

  private parsePrice(value: string): number {
    if (!value) return 0;

    const cleaned = value.replace(/[^0-9.]/g, '');
    return Number(cleaned) || 0;
  }

  async refreshFromQuote(){
    if (!this.child) return;
    await this.child.GetServiceDetail();
    await this.child.SaveAppointmentData();
  }

  async openExpiredQuote(){
    await this.appointmentService.UpdateQuoteExpireDate(this.editAppointmentService.appointmentDetails.id).then(res =>{
      if(res){
        let activateAppointment = this.translate.instant("lblQuoteReOpened");
        this.toastr.success(activateAppointment);
        this.editAppointmentService.appointmentDetails.isQuoteExipred = false;
        this.onRefresh();
      }
      else{
        this.spinner.hide();
      }
    })
  }
  //#endregion
}
